import Enumerable from "linq";
import { Document } from "../Document";
import { IDocumentAlert } from "../IDocumentAlert";
import { IDocumentValidatable } from "../IDocumentValidatable";
import { IItem } from "../items";

export abstract class AbstractItemsValidator implements IDocumentValidatable {
  public validate(document: Document): IDocumentAlert[] {
    return Enumerable.from(document.itemSets)
      .select((s, i) => Enumerable.from(this.validateItems(s.items, i)).where(a => !!a).toArray())
      .aggregate([] as IDocumentAlert[], (s, a) => s.concat(a));
  }

  protected abstract validateItems(items: IItem[], itemSetId: number): IDocumentAlert[];
}
